module.exports = __webpack_public_path__ + "img/dryer-heat.71449e6c.svg";